import React from 'react'
import { Popover } from 'react-bootstrap'

const DescriptionTooltip = ( description ) => {
    return (
        <Popover id="popover-description">
            <Popover.Content>{description}</Popover.Content>
        </Popover>
    )
}

export default DescriptionTooltip